import floor from './floor-default.png?url';
import wall from './wall-default.png?url';

const materialDefaultImageUrl = {
  floor,
  wall
};

export { materialDefaultImageUrl };
